/* eslint-disable import/no-unresolved */

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

import { PaginationArrow } from 'components/pagination/pagination-component';
import { Post } from 'components/post/post-component';
import { Fragment, SetStateAction, useState } from 'react';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import { RelatedPost, RelatedPostsProps } from './related-posts-types';

const RelatedPosts = ({ posts }: RelatedPostsProps) => {
  const [previousElement, setPreviousElement] = useState<
    HTMLElement | null | undefined
  >();
  const [nextElement, setNextElement] = useState<
    HTMLElement | null | undefined
  >();

  return (
    <Fragment>
      <div className="container mx-auto hidden px-4 md:inline">
        <Swiper
          modules={[Navigation]}
          spaceBetween={50}
          navigation={{
            prevEl: previousElement ?? null,
            nextEl: nextElement ?? null,
          }}
          slidesPerView={3}
        >
          {posts.map((post: RelatedPost, index) => (
            <SwiperSlide key={index}>
              <Post
                variant="related"
                description=""
                title={post.title}
                img={post.img}
                link={post.link}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <div className="container mx-auto hidden sm:inline md:hidden">
        <Swiper
          modules={[Navigation]}
          spaceBetween={50}
          navigation={{
            prevEl: previousElement ?? null,
            nextEl: nextElement ?? null,
          }}
          slidesPerView={2}
        >
          {posts.map((post: RelatedPost, index) => (
            <SwiperSlide key={index}>
              <Post
                variant="related"
                description=""
                title={post.title}
                img={post.img}
                link={post.link}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <div className="container mx-auto sm:hidden">
        <Swiper
          modules={[Navigation]}
          spaceBetween={50}
          navigation={{
            prevEl: previousElement ?? null,
            nextEl: nextElement ?? null,
          }}
          slidesPerView={1}
        >
          {posts.map((post: RelatedPost, index) => (
            <SwiperSlide key={index}>
              <Post
                variant="related"
                description=""
                title={post.title}
                img={post.img}
                link={post.link}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <PaginationArrow
        onPrevClick={(node: SetStateAction<HTMLElement | null | undefined>) =>
          setPreviousElement(node)
        }
        canGoNext={!nextElement}
        onNextClick={(node: SetStateAction<HTMLElement | null | undefined>) =>
          setNextElement(node)
        }
        canGoPrev={!previousElement}
      />
    </Fragment>
  );
};

export default RelatedPosts;
